"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_native_paper_dates_1 = require("react-native-paper-dates");
const styles_1 = __importDefault(require("../../styles/styles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const select_1 = __importDefault(require("../select/select"));
const ticketConstants_1 = require("../../features/ticket/ticketConstants");
const ticketSlice_1 = require("../../features/ticket/ticketSlice");
const button_1 = __importDefault(require("../button/button"));
const eventConstants_1 = require("../../constants/eventConstants");
const utils_1 = require("../../utils/utils");
const pressable_1 = __importDefault(require("../pressable/pressable"));
const ticketUtils_1 = require("../ticketComponent/ticketUtils");
const officersSlice_1 = require("../../features/officer/officersSlice");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const FilterTicket = ({ queryParams, setQueryParams }) => {
    const today = new Date();
    const dispatch = useAppDispatch_1.default();
    const { officers } = useAppSelector_1.default((state) => ({
        officers: state.officers.officers.data,
    }));
    const [priority, setPriority] = react_1.useState(queryParams.priority);
    const [assignedTeam, setAssignedTeam] = react_1.useState(queryParams.assigned_team);
    const [reporterType, setReporterType] = react_1.useState(queryParams.reporter_type);
    const [source, setSource] = react_1.useState(queryParams.source);
    const [type, setType] = react_1.useState(queryParams.type);
    const [status, setStatus] = react_1.useState(queryParams.status);
    const [origin, setOrigin] = react_1.useState(queryParams.origin);
    const [ticketDate, setTicketDate] = react_1.useState(queryParams.ticket_date ? new Date(queryParams.ticket_date) : undefined);
    const [ticketDateModalVisible, setTicketDateModalVisible] = react_1.useState(false);
    const formattedTicketDate = ticketDate && utils_1.formatDateISOString(ticketDate);
    react_1.useEffect(() => {
        dispatch(officersSlice_1.getOfficers({}));
    }, []);
    const onSearch = (input) => ticketUtils_1.searchOfficers(dispatch, input);
    const officerChoices = ticketUtils_1.generateOfficerChoices(officers);
    const onDateModalConfirm = (params) => {
        setTicketDateModalVisible(false);
        setTicketDate(params.date);
    };
    const onSubmit = (payload) => {
        const updatedPayload = {
            ...payload,
            priority,
            assigned_team: assignedTeam,
            reporter_type: reporterType,
            ticket_date: formattedTicketDate,
            origin,
            status,
            source,
            type,
        };
        dispatch(ticketSlice_1.getTickets(updatedPayload));
        setQueryParams(updatedPayload);
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles] },
        react_1.default.createElement(formik_1.Formik, { initialValues: queryParams, onSubmit: (values) => onSubmit(values) }, ({ handleChange, handleSubmit, values }) => (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_paper_dates_1.DatePickerModal, { locale: "en", mode: "single", visible: ticketDateModalVisible, onDismiss: () => setTicketDateModalVisible(false), date: ticketDate, onConfirm: onDateModalConfirm, label: "Select ticket date", validRange: {
                    endDate: today,
                } }),
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Ticket ID", onChangeText: handleChange('id'), value: values.id || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Ticket Reference ID", onChangeText: handleChange('reference_id'), value: values.reference_id || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Customer ID", onChangeText: handleChange('customer_id'), value: values.customer_id || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Name", onChangeText: handleChange('name'), value: values.name || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Email", onChangeText: handleChange('email'), value: values.email || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Phone Number", onChangeText: handleChange('phone_number'), value: values.phone_number || '', style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput }),
            react_1.default.createElement(pressable_1.default, { onPress: () => setTicketDateModalVisible(true), eventName: eventConstants_1.SELECT_TICKET_DATE_BUTTON },
                react_1.default.createElement(react_native_paper_1.TextInput, { label: "Ticket Date", value: formattedTicketDate, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginBottomTen },
                react_1.default.createElement(react_native_paper_1.Title, { style: [
                        styles_1.default.textColorBlack,
                        styles_1.default.fontSizeText,
                        styles_1.default.marginLeftTen,
                    ] }, `Reporter `),
                react_1.default.createElement(select_1.default, { value: values.reporter_id, setValue: () => { }, setValueFormik: handleChange('reporter_id'), choices: officerChoices, style: [styles_1.default.select], searchable: true, onSearch: onSearch })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginBottomTen },
                react_1.default.createElement(react_native_paper_1.Title, { style: [
                        styles_1.default.textColorBlack,
                        styles_1.default.fontSizeText,
                        styles_1.default.marginLeftTen,
                    ] }, `Assigned Officer `),
                react_1.default.createElement(select_1.default, { value: values.assigned_officer_id, setValue: () => { }, setValueFormik: handleChange('assigned_officer_id'), choices: officerChoices, style: styles_1.default.select, searchable: true, onSearch: onSearch })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginBottomTen },
                react_1.default.createElement(react_native_paper_1.Title, { style: [
                        styles_1.default.textColorBlack,
                        styles_1.default.fontSizeText,
                        styles_1.default.marginLeftTen,
                    ] }, `Subject `),
                react_1.default.createElement(select_1.default, { value: values.subject, setValue: () => { }, setValueFormik: handleChange('subject'), choices: ticketConstants_1.TICKET_SUBJECT, style: styles_1.default.select, searchable: true, onSearch: onSearch })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginBottomTen] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginRightTen] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [
                            styles_1.default.textColorBlack,
                            styles_1.default.fontSizeText,
                            styles_1.default.marginLeftTen,
                        ] }, `Status `),
                    react_1.default.createElement(select_1.default, { value: status, setValue: setStatus, choices: ticketConstants_1.STATUS_CHOICES })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [
                            styles_1.default.textColorBlack,
                            styles_1.default.fontSizeText,
                            styles_1.default.marginLeftTen,
                        ] }, `Priority `),
                    react_1.default.createElement(select_1.default, { value: priority, setValue: setPriority, choices: ticketConstants_1.PRIORITY_CHOICES }))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginBottomTen] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginRightTen] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [
                            styles_1.default.textColorBlack,
                            styles_1.default.fontSizeText,
                            styles_1.default.marginLeftTen,
                        ] }, `Source `),
                    react_1.default.createElement(select_1.default, { value: source, setValue: setSource, choices: ticketConstants_1.TICKET_SOURCE_CHOICES })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [
                            styles_1.default.textColorBlack,
                            styles_1.default.fontSizeText,
                            styles_1.default.marginLeftTen,
                        ] }, `Type `),
                    react_1.default.createElement(select_1.default, { value: type, setValue: setType, choices: ticketConstants_1.TICKET_TYPE_CHOICES }))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginBottomTen] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginRightTen] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [
                            styles_1.default.textColorBlack,
                            styles_1.default.fontSizeText,
                            styles_1.default.marginLeftTen,
                        ] }, `Assigned Team `),
                    react_1.default.createElement(select_1.default, { value: assignedTeam, setValue: setAssignedTeam, choices: ticketConstants_1.ASSIGNED_TEAM_CHOICES })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [
                            styles_1.default.textColorBlack,
                            styles_1.default.fontSizeText,
                            styles_1.default.marginLeftTen,
                        ] }, `Reporter Type `),
                    react_1.default.createElement(select_1.default, { value: reporterType, setValue: setReporterType, choices: ticketConstants_1.OFFICER_TYPES_CHOICES }))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginBottomTen] },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [
                            styles_1.default.textColorBlack,
                            styles_1.default.fontSizeText,
                            styles_1.default.marginLeftTen,
                        ] }, `Origin `),
                    react_1.default.createElement(select_1.default, { value: origin, setValue: setOrigin, choices: ticketConstants_1.TICKET_ORIGIN_CHOICES }))),
            react_1.default.createElement(button_1.default, { fill: true, text: "Filter", icon: free_solid_svg_icons_1.faSearchPlus, onPress: handleSubmit, eventName: eventConstants_1.FILTER_TICKET_BUTTON }))))));
};
exports.default = FilterTicket;
